import { Button, useGetList, useNotify } from 'react-admin'
import { GetApp } from '@mui/icons-material'
import { useState } from 'react'

const createGlobalSheet = async (workbook, hippocastData, selectedMonth) => {
  // Build filter for global data
  let globalHippocastData = hippocastData.filter(data => 
    data.center_id === process.env.REACT_APP_CENTER_GLOBAL &&
    data.is_global === 1 &&
    data.is_monthly === (selectedMonth ? 1 : 0)
  )
  
  // Add date filter if month is selected
  if (selectedMonth) {
    const [year, month] = selectedMonth.split('-')
    const startDate = new Date(parseInt(year), parseInt(month) - 1, 1)
    const endDate = new Date(parseInt(year), parseInt(month), 0)
    
    globalHippocastData = globalHippocastData.filter(data => {
      const itemDate = data.created_at.split('T')[0]
      return itemDate >= startDate.toISOString().split('T')[0] &&
             itemDate <= endDate.toISOString().split('T')[0]
    })
  }
  
  // Create worksheet for global data
  const worksheet = workbook.addWorksheet('TOUS', {
    properties: { tabColor: { argb: 'FF000000' } }
  })
  
  setupWorksheet(worksheet, globalHippocastData, 'Global')
}

const createCenterSheet = async (workbook, hippocastData, center, selectedMonth) => {
  // Build filter for center data
  let centerHippocastData = hippocastData.filter(data => 
    data.center_id === center.id &&
    data.is_global === 0 &&
    data.is_monthly === (selectedMonth ? 1 : 0)
  )
  
  // Add date filter if month is selected
  if (selectedMonth) {
    const [year, month] = selectedMonth.split('-')
    const startDate = new Date(parseInt(year), parseInt(month) - 1, 1)
    const endDate = new Date(parseInt(year), parseInt(month), 0)
    
    centerHippocastData = centerHippocastData.filter(data => {
      const itemDate = data.created_at.split('T')[0]
      return itemDate >= startDate.toISOString().split('T')[0] &&
             itemDate <= endDate.toISOString().split('T')[0]
    })
  }
  
  // Create worksheet for this center
  const worksheet = workbook.addWorksheet(center.name, {
    properties: { tabColor: { argb: center.color?.replace('#', '') || 'FFFFFF' } }
  })
  
  setupWorksheet(worksheet, centerHippocastData, center.name)
}

const setupWorksheet = (worksheet, data, sheetName) => {
  const toStatusBreakdown = item => {
    try {
      return typeof item.status_breakdown === 'string'
        ? JSON.parse(item.status_breakdown)
        : (item.status_breakdown || {})
    } catch {
      return {}
    }
  }

  // Order rows
  const eventOrder = [
    'Appli uniquement',
    'Webinaire uniquement',
    'RDV uniquement',
    'Appli + Webinaire (sans RDV)',
    'Appli + RDV (sans Webinaire)',
    'Webinaire + RDV (sans Appli)',
    'Appli + Webinaire + RDV (Tous présents)',
    'Total confondu'
  ]

  const sortedData = [...data].sort((a, b) => {
    const ia = eventOrder.indexOf(a.event_name)
    const ib = eventOrder.indexOf(b.event_name)
    if (ia === -1 && ib === -1) return 0
    if (ia === -1) return 1
    if (ib === -1) return -1
    return ia - ib
  })

  // Define all columns (matching datagrid exactly)
  worksheet.columns = [
    { header: 'Évènement', key: 'event_name', width: 40 },
    { header: 'Total Envoyés', key: 'total_sent', width: 15 },
    { header: 'Total Importé', key: 'total_imported', width: 15 },

    // Hippocast leads
    { header: 'Total Nouveaux', key: 'new_leads', width: 18 },
    { header: 'Leads Nouveaux Inscrits', key: 'sub_new_leads', width: 25 },

    // PASS 26-27
    { header: 'PASS 26-27', key: 'new_pass_2627', width: 15 },
    { header: 'PASS 26-27 + TS 25-26 année passée', key: 'new_pass_2627_ts_2526_done', width: 35 },
    { header: 'PASS 26-27 + TS 25-26', key: 'new_pass_2627_ts_2526', width: 25 },
    { header: 'PASS 26-27 + P0 25-26 année passée', key: 'new_pass_2627_p0_2526_done', width: 35 },
    { header: 'PASS 26-27 + P0 25-26', key: 'new_pass_2627_p0_2526', width: 25 },

    // L1SPS 26-27
    { header: 'L1SPS 26-27', key: 'new_l1sps_2627', width: 15 },
    { header: 'L1SPS 26-27 + TS 25-26 année passée', key: 'new_l1sps_2627_ts_2526_done', width: 35 },
    { header: 'L1SPS 26-27 + TS 25-26', key: 'new_l1sps_2627_ts_2526', width: 25 },
    { header: 'L1SPS 26-27 + P0 25-26 année passée', key: 'new_l1sps_2627_p0_2526_done', width: 35 },
    { header: 'L1SPS 26-27 + P0 25-26', key: 'new_l1sps_2627_p0_2526', width: 25 },

    // LAS 26-27
    { header: 'LAS 26-27', key: 'new_las_2627', width: 15 },
    { header: 'LAS 26-27 + TS 25-26 année passée', key: 'new_las_2627_ts_2526_done', width: 35 },
    { header: 'LAS 26-27 + TS 25-26', key: 'new_las_2627_ts_2526', width: 25 },
    { header: 'LAS 26-27 + P0 25-26 année passée', key: 'new_las_2627_p0_2526_done', width: 35 },
    { header: 'LAS 26-27 + P0 25-26', key: 'new_las_2627_p0_2526', width: 25 },

    // Individual status - new
    { header: 'TS 25-26', key: 'new_ts_2526', width: 15 },
    { header: 'TS 26-27', key: 'new_ts_2627', width: 15 },
    { header: 'P0 25-26', key: 'new_p0_2526', width: 15 },
    { header: 'P0 26-27', key: 'new_p0_2627', width: 15 },
    { header: 'PS 25-26', key: 'new_ps_2526', width: 15 },
    { header: 'PS 26-27', key: 'new_ps_2627', width: 15 },

    // CRM leads
    { header: 'Total Présents CRM', key: 'crm_leads', width: 20 },
    { header: 'Leads Présents Inscrits', key: 'sub_crm_leads', width: 25 },

    // PASS 26-27 CRM
    { header: 'CRM PASS 26-27', key: 'crm_pass_2627', width: 18 },
    { header: 'CRM PASS 26-27 + TS 25-26', key: 'crm_pass_2627_ts_2526', width: 28 },
    { header: 'CRM PASS 26-27 + P0 25-26', key: 'crm_pass_2627_p0_2526', width: 28 },

    // L1SPS 26-27 CRM
    { header: 'CRM L1SPS 26-27', key: 'crm_l1sps_2627', width: 18 },
    { header: 'CRM L1SPS 26-27 + TS 25-26', key: 'crm_l1sps_2627_ts_2526', width: 28 },
    { header: 'CRM L1SPS 26-27 + P0 25-26', key: 'crm_l1sps_2627_p0_2526', width: 28 },

    // LAS 26-27 CRM
    { header: 'CRM LAS 26-27', key: 'crm_las_2627', width: 18 },
    { header: 'CRM LAS 26-27 + TS 25-26', key: 'crm_las_2627_ts_2526', width: 28 },
    { header: 'CRM LAS 26-27 + P0 25-26', key: 'crm_las_2627_p0_2526', width: 28 },

    // Individual status - CRM
    { header: 'CRM TS 25-26', key: 'crm_ts_2526', width: 15 },
    { header: 'CRM TS 26-27', key: 'crm_ts_2627', width: 15 },
    { header: 'CRM P0 25-26', key: 'crm_p0_2526', width: 15 },
    { header: 'CRM P0 26-27', key: 'crm_p0_2627', width: 15 },
    { header: 'CRM PS 25-26', key: 'crm_ps_2526', width: 15 },
    { header: 'CRM PS 26-27', key: 'crm_ps_2627', width: 15 },
  ]

  // Header styles
  const colors = {
    blue: 'c3d2ec',
    grey: 'FFE7E6E6',
    green: 'C6EFCE',
    orange: 'FFEB9C',
  }

  // Column ranges for coloring
  const newLeadsStart = 4   // new_leads
  const newLeadsEnd = 28    // new_ps_2627
  const crmLeadsStart = 29  // crm_leads
  const crmLeadsEnd = 44    // crm_ps_2627

  const header = worksheet.getRow(1)
  header.eachCell((cell, col) => {
    let bg = colors.blue

    if (col === 1) {
      bg = colors.grey
    } else if (col >= newLeadsStart && col <= newLeadsEnd) {
      bg = colors.green
    } else if (col >= crmLeadsStart && col <= crmLeadsEnd) {
      bg = colors.orange
    }

    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bg } }
    cell.font = { bold: true, color: { argb: 'FF000000' } }
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
  })

  // Add data rows
  for (const item of sortedData) {
    const sb = toStatusBreakdown(item)

    const rowObj = {
      event_name: item.event_name,
      total_sent: item.total_sent === 0 ? 'NA' : item.total_sent,
      total_imported: item.total_imported,

      new_leads: item.new_leads || 0,
      sub_new_leads: item.sub_new_leads || 0,

      // PASS 26-27
      new_pass_2627: sb?.new_pass_2627 || 0,
      new_pass_2627_ts_2526_done: sb?.new_pass_2627_ts_2526_done || 0,
      new_pass_2627_ts_2526: sb?.new_pass_2627_ts_2526 || 0,
      new_pass_2627_p0_2526_done: sb?.new_pass_2627_p0_2526_done || 0,
      new_pass_2627_p0_2526: sb?.new_pass_2627_p0_2526 || 0,

      // L1SPS 26-27
      new_l1sps_2627: sb?.new_l1sps_2627 || 0,
      new_l1sps_2627_ts_2526_done: sb?.new_l1sps_2627_ts_2526_done || 0,
      new_l1sps_2627_ts_2526: sb?.new_l1sps_2627_ts_2526 || 0,
      new_l1sps_2627_p0_2526_done: sb?.new_l1sps_2627_p0_2526_done || 0,
      new_l1sps_2627_p0_2526: sb?.new_l1sps_2627_p0_2526 || 0,

      // LAS 26-27
      new_las_2627: sb?.new_las_2627 || 0,
      new_las_2627_ts_2526_done: sb?.new_las_2627_ts_2526_done || 0,
      new_las_2627_ts_2526: sb?.new_las_2627_ts_2526 || 0,
      new_las_2627_p0_2526_done: sb?.new_las_2627_p0_2526_done || 0,
      new_las_2627_p0_2526: sb?.new_las_2627_p0_2526 || 0,

      // Individual status - new
      new_ts_2526: sb?.new_ts_2526 || 0,
      new_ts_2627: sb?.new_ts_2627 || 0,
      new_p0_2526: sb?.new_p0_2526 || 0,
      new_p0_2627: sb?.new_p0_2627 || 0,
      new_ps_2526: sb?.new_ps_2526 || 0,
      new_ps_2627: sb?.new_ps_2627 || 0,

      // CRM leads
      crm_leads: item.crm_leads || 0,
      sub_crm_leads: item.sub_crm_leads || 0,

      crm_pass_2627: sb?.crm_pass_2627 || 0,
      crm_pass_2627_ts_2526: sb?.crm_pass_2627_ts_2526 || 0,
      crm_pass_2627_p0_2526: sb?.crm_pass_2627_p0_2526 || 0,

      crm_l1sps_2627: sb?.crm_l1sps_2627 || 0,
      crm_l1sps_2627_ts_2526: sb?.crm_l1sps_2627_ts_2526 || 0,
      crm_l1sps_2627_p0_2526: sb?.crm_l1sps_2627_p0_2526 || 0,

      crm_las_2627: sb?.crm_las_2627 || 0,
      crm_las_2627_ts_2526: sb?.crm_las_2627_ts_2526 || 0,
      crm_las_2627_p0_2526: sb?.crm_las_2627_p0_2526 || 0,

      crm_ts_2526: sb?.crm_ts_2526 || 0,
      crm_ts_2627: sb?.crm_ts_2627 || 0,
      crm_p0_2526: sb?.crm_p0_2526 || 0,
      crm_p0_2627: sb?.crm_p0_2627 || 0,
      crm_ps_2526: sb?.crm_ps_2526 || 0,
      crm_ps_2627: sb?.crm_ps_2627 || 0,
    }

    const row = worksheet.addRow(rowObj)

    row.eachCell((cell, col) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }

      // Align numbers to the right
      if (col > 1) {
        cell.alignment = { horizontal: 'right' }
      }
    })

    // Highlight "Total confondu" row
    if (item.event_name === 'Total confondu') {
      row.eachCell(cell => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: colors.grey } }
        cell.font = { bold: true }
      })
    }
  }

  // Handle empty data
  if (sortedData.length === 0) {
    const r = worksheet.addRow({ event_name: `Aucune donnée pour ${sheetName}` })
    r.getCell(1).font = { italic: true }
  }
}

const ExportExcelButton = ({ selectedMonth }) => {
  const notify = useNotify()
  const [isLoading, setIsLoading] = useState(false)

  const { data: hippocastData, loading: hippocastLoading } = useGetList(
    'hippocast_summary',
    {
      pagination: { page: 1, perPage: 9999 },
      sort: { field: 'event_name', order: 'ASC' },
    }
  )

  const { data: centersData, loading: centersLoading } = useGetList(
    'centers',
    {
      pagination: { page: 1, perPage: 50 },
      sort: { field: 'name', order: 'ASC' },
    }
  )

  const excludedNames = [
    'CAP CRC', 'CAP IRA', 'Global', 'CAP TA', 'Artec Formation', 'Azap Formation', 
    'Capavocat', 'EDN Hippocrate', 'INFPS-Campus', 'Mission Avocat', 'Mission Droit', 
    'Mission Magistrat', 'MyPrepa', 'SupOrtho', 'Symphonie Accompagnements',
    'Étudiant en droit', 'Supexam Paris'
  ].map(name => name.toLowerCase())

  const centers = centersData?.filter(center => 
    !excludedNames.includes(center.name?.toLowerCase())
  )

  const handleExport = async () => {
    try {
      setIsLoading(true)

      const { default: ExcelJS } = await import('exceljs')
      const workbook = new ExcelJS.Workbook()
      workbook.creator = 'Hippocast Dashboard'
      workbook.created = new Date()

      // Add Global sheet first
      await createGlobalSheet(workbook, hippocastData, selectedMonth)

      // Process each center
      for (const center of centers) {
        await createCenterSheet(workbook, hippocastData, center, selectedMonth)
      }

      // Generate filename
      const monthText = selectedMonth 
        ? `_${selectedMonth.replace('-', '_')}`
        : '_global'
      const filename = `hippocast_export${monthText}_${new Date().toISOString().split('T')[0]}.xlsx`

      // Download file
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
      
      notify('Export Excel terminé avec succès', { type: 'success' })
    } catch (error) {
      console.error('Export error:', error)
      notify('Impossible de générer le fichier Excel', { type: 'error' })
    } finally {
      setIsLoading(false)
    }
  }

  return (centersLoading || hippocastLoading) ? <></> : (
    <Button
      label="Exporter"
      onClick={handleExport}
      variant="contained"
      sx={{ ml: 1 }}
      loading={isLoading}
    >
      <GetApp />
    </Button>
  )
}

export default ExportExcelButton